module.exports = __webpack_public_path__ + "media/theme/dot-border-3f2a96f1.png";